import React from "react";
import { Wrapper } from "./Input.styled";

export const Input = ({ value, onChange, className, type = "text", placeholder, name, required, status, ...props }) => {
    return (
        <>
            <Wrapper
                value={value}
                className={className}
                onChange={onChange}
                type={type}
                placeholder={placeholder}
                {...props}
                name={name}
                required={required}
                status={status}
            />
        </>
    );
};
